export const getYear = state => state.reportDispatcherKPI.getIn(['list', 'year'])
export const getData = state => state.reportDispatcherKPI.getIn(['list', 'data'])
export const getFetching = state => state.reportDispatcherKPI.getIn(['list', 'fetching'])
export const getError = state => state.reportDispatcherKPI.getIn(['list', 'error'])
